import { addEvents } from '../../helpers/dom/addEvents';
import { ancestorBySelector } from '../../helpers/element/findAncestor';

class Input {
    constructor(elem) {
        this.input = elem;
        this.parent = null;

        this.getElements();
        this.setEvents();
        this.checkInput();
    }

    getElements() {
        this.parent = ancestorBySelector(this.input, '.af-field');
    }
    setEvents() {
        addEvents(this.input, ['keydown', 'keyup'], () => {
            this.checkInput(this.input);
        });
    }

    checkInput() {
        if (this.input.max !== "") {
            if (parseInt(this.input.value, 10) > parseInt(this.input.max, 10)) {
                this.input.value = this.input.max;
            }
        }
    }
}

export function initCalculatorInputs() {
    const text = document.querySelectorAll('.af-field-type-text input');
    const email = document.querySelectorAll('.af-field-type-email input');
    const number = document.querySelectorAll('.af-field-type-number:not(.af-field-quantity) input');

    const inputs = [...text, ...email, ...number];

    if (inputs.length > 0) {
        inputs.forEach((input) => {
            new Input(input);
        });
    }
};

